import { render, staticRenderFns } from "./DashboardRoot.vue?vue&type=template&id=0b225342&"
import script from "./DashboardRoot.vue?vue&type=script&lang=js&"
export * from "./DashboardRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports